export default __webpack_public_path__ + "roboto-v27-latin-700.52327c41eefb552d40746a37266bf17f.ttf";